import React from 'react'
import ReactDOM from 'react-dom'
import { createStore, applyMiddleware, compose } from 'redux'
import { Provider } from 'react-redux'
import reducer from './Reducers/index'
import thunk from 'redux-thunk'
import App from './App'
import { MuiThemeProvider } from '@material-ui/core/styles'
import { BrowserRouter as Router } from 'react-router-dom'
import './index.css'

import theme from './styles/theme'

require('dotenv').config({ path: '../.env' })

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
const store = createStore(reducer, composeEnhancers(applyMiddleware(thunk)))

ReactDOM.render(
  <Provider store={store}>
    <Router>
      <MuiThemeProvider theme={theme}>
        <App />
        {/* <HOC /> */}
      </MuiThemeProvider>
    </Router>
  </Provider>
  ,
  document.getElementById('root')
)
